import { render, staticRenderFns } from "./RiChang3.vue?vue&type=template&id=2bbee411&scoped=true&"
import script from "./RiChang3.vue?vue&type=script&lang=js&"
export * from "./RiChang3.vue?vue&type=script&lang=js&"
import style0 from "./RiChang3.vue?vue&type=style&index=0&id=2bbee411&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbee411",
  null
  
)

export default component.exports